import Vue from 'vue';
import Router from 'vue-router';
import store from "../store";
import ProjectList from "@/views/ProjectList";
import ProjectDetail from "@/views/ProjectDetail";
import SummaryDetail from "@/views/SummaryDetail";
import EmptyRouterView from "@/views/EmptyRouterView";
import EquipmentList from "@/views/EquipmentList.vue";

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

// Views
const Dashboard = () => import('@/views/Dashboard');

// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');
const Login = () => import('@/views/pages/Login');
const Register = () => import('@/views/pages/Register');

// Users
const Users = () => import('@/views/users/Users');
const User = () => import('@/views/users/User');
const LogOut = () => import('@/views/auth/LogOut');
const ForgotPassword = () => import('@/views/ForgotPassword');
const SetPasswordForm = () => import('@/views/SetPasswordForm');
const ChangePassword = () => import('@/views/ChangePasswordForm');

const AccountDetail = () => import('@/views/AccountDetail');
const TicketForm = () => import('@/views/TicketForm');
const IncidentDetail = () => import('@/views/IncidentDetail');
const IncidentList = () => import('@/views/IncidentList');
const TicketList = () => import('@/views/TicketList');
const TicketDetail = () => import('@/views/TicketDetail');
const ContractList = () => import('@/views/ContractList');
const ClientProductList = () => import('@/views/ClientProductList');
const InvoiceList = () => import('@/views/InvoiceList');
const WorkProjectList = () => import('@/views/WorkProjectList');
const WorkshopIncidentList = () => import('@/views/WorkshopIncidentList');
const UpdateAccount = () => import('@/views/UpdateAccount');
const MaintenanceContractList = () => import('@/views/MaintenanceContractList');
const PendingAuthTicketList = () => import('@/views/PendingAuthTicketList');
const ServiceTicketDetail = () => import('@/views/ServiceTicketDetail');
const InvoiceDetail = () => import('@/views/InvoiceDetail');
const QuoteList = () => import('@/views/QuoteList');
const QuoteDetail = () => import('@/views/QuoteDetail');
const WorkProjectDetail = () => import('@/views/WorkProjectDetail');
const VisitTicketDetail = () => import('@/views/VisitTicketDetail');
const WorkshopIncidentDetail = () => import('@/views/WorkshopIncidentDetail');
const MainDashboard = () => import('@/views/MainDashboard');
const ZoningList = () => import('@/views/ZoningList');
const TravelExpenseDetail = () => import('@/views/TravelExpenseDetail');
const TravelExpenseList = () => import('@/views/TravelExpenseList');

Vue.use(Router);

function configRoutes() {
	return [
		{
			path: '/',
			redirect: '/accounts',
			name: 'Inicio',
			component: DefaultContainer,
			meta: {
				label: 'Inicio'
			},
			children: [
				{
					path: 'dashboard',
					name: 'Dashboard',
					component: Dashboard,
					meta: {
						requiresAuth: true
					}
				},
				{
					path: 'main-dashboard',
					name: 'MainDashboard',
					component: MainDashboard,
					meta: {
						label: 'Dashboard',
						requiresAuth: true
					}
				},
				{
					path: 'projects',
					name: 'ProjectList',
					redirect: 'projects/',
					component: EmptyRouterView,
					meta: {
						label: 'Proyectos',
						requiresAuth: true
					},
					children: [
						{
							path: '',
							component: ProjectList,
							meta: {
								requiresAuth: true
							}
						},
						{
							path: ':id',
							name: 'Project',
							redirect: ':id',
							component: EmptyRouterView,
							meta: {
								label: 'Detalle',
								requiresAuth: true
							},
							children: [
								{
									path: '',
									name: 'ProjectDetail',
									component: ProjectDetail,
									meta: {
										requiresAuth: true,
										label: 'Proyecto'
									}
								},
								{
									path: 'summary/:summaryId',
									name: 'SummaryDetail',
									component: SummaryDetail,
									meta: {
										label: 'Detalle de Minuta',
										requiresAuth: true
									}
								}
							]
						},
					]
				},
				{
					path: '/equipment-list',
					name: 'Equipment-List',
					component: EquipmentList,
					meta: {
						label: 'Lista de Equipos',
						requiresAuth: true
					}
				},
				{
					path: 'accounts',
					name: 'Accounts',
					redirect: 'accounts/list',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					meta: {
						label: 'Sucursales',
						requiresAuth: true
					},
					children: [
						{
							path: 'list',
							component: Dashboard,
							meta: {
								requiresAuth: true
							},
						},
						{
							path: 'pending-auth-tickets',
							name: 'PendingAuthTicketList',
							component: PendingAuthTicketList,
							meta: {
								label: 'Tickets Pendientes de Autorización',
								requiresAuth: true
							}
						},
						{
							path: 'account',
							name: 'AccountRoot',
							redirect: 'account/detail',
							component: {
								render(c) {
									return c('router-view')
								}
							},
							meta: {
								requiresAuth: true,
								label: 'Detalle de Cuenta',
							},
							children: [
								{
									path: 'detail/:id',
									name: 'AccountDetail',
									component: AccountDetail,
									meta: {
										requiresAuth: true,
										label: 'Detalle de Cuenta',
										bcDynamic: true
									},
								},
								{
									path: 'update',
									name: 'AccountUpdate',
									component: UpdateAccount,
									meta: {
										requiresAuth: true,
										label: 'Actualizar Datos de la Cuenta',
										bcDynamic: true
									},
								},
								{
									path: 'create-ticket',
									name: 'CreateTicket',
									component: TicketForm,
									meta: {
										label: 'Agregar Ticket',
										requiresAuth: true
									}
								},
								{
									path: 'incident-detail/:id',
									name: 'IncidentDetail',
									component: IncidentDetail,
									meta: {
										label: 'Detalles del Caso',
										requiresAuth: true
									}
								},
								{
									path: 'incidents',
									name: 'IncidentList',
									component: IncidentList,
									meta: {
										label: 'Casos',
										requiresAuth: true
									}
								},
								{
									path: 'tickets',
									name: 'Tickets',
									component: TicketList,
									meta: {
										label: 'Tickets',
										requiresAuth: true
									}
								},
								{
									path: 'ticket-detail/:id',
									name: 'TicketDetail',
									component: TicketDetail,
									meta: {
										label: 'Detalles del Ticket',
										requiresAuth: true
									}
								},
								{
									path: 'maintenance-contracts',
									name: 'MaintenanceContracts',
									component: MaintenanceContractList,
									meta: {
										label: 'Contratos de Mantenimiento',
										requiresAuth: true
									}
								},
								{
									path: 'contracts',
									name: 'Contracts',
									component: ContractList,
									meta: {
										label: 'Contratos de Monitoreo',
										requiresAuth: true
									}
								},
								{
									path: 'client-products',
									name: 'ClientProductList',
									component: ClientProductList,
									meta: {
										label: 'Equipos del Cliente',
										requiresAuth: true
									}
								},
								{
									path: 'invoices',
									name: 'Invoices',
									component: InvoiceList,
									meta: {
										label: 'Facturas',
										requiresAuth: true
									}
								},
								{
									path: 'invoice-detail/:id',
									name: 'InvoiceDetail',
									component: InvoiceDetail,
									meta: {
										label: 'Detalle de Factura',
										requiresAuth: true
									}
								},
								{
									path: 'quotes',
									name: 'Quotes',
									component: QuoteList,
									meta: {
										label: 'Cotizaciones',
										requiresAuth: true
									}
								},
								{
									path: 'quote-detail/:id',
									name: 'QuoteDetail',
									component: QuoteDetail,
									meta: {
										label: 'Detalle de Cotización',
										requiresAuth: true
									}
								},
								{
									path: 'work-projects',
									name: 'WorkProjects',
									component: WorkProjectList,
									meta: {
										label: 'Proyectos',
										requiresAuth: true
									}
								},
								{
									path: 'work-project/:id',
									name: 'WorkProjectDetail',
									component: WorkProjectDetail,
									meta: {
										label: 'Detalle de Comienzo de Trabajo (Proyecto)',
										requiresAuth: true
									}
								},
								{
									path: 'workshop-incidents',
									name: 'WorkshopIncidents',
									component: WorkshopIncidentList,
									meta: {
										label: 'Casos de Taller',
										requiresAuth: true
									}
								},
								{
									path: 'workshop-incident-detail/:id',
									name: 'WorkshopIncidentDetail',
									component: WorkshopIncidentDetail,
									meta: {
										label: 'Detalle de Caso de Taller',
										requiresAuth: true
									}
								},
								{
									path: 'service-ticket-detail/:id',
									name: 'ServiceTicketDetail',
									component: ServiceTicketDetail,
									meta: {
										label: 'Boleta de Servicio',
										requiresAuth: true
									}
								},
								{
									path: 'work-project/visit-ticket/:id',
									name: 'VisitTicketDetail',
									component: VisitTicketDetail,
									meta: {
										label: 'Boleta de Servicio (CDT)',
										requiresAuth: true
									}
								},
								{
									path: 'zoning',
									name: 'ZoningList',
									component: ZoningList,
									meta: {
										label: 'Zonificación',
										requiresAuth: true
									}
								},
								{
									path: 'travel-expense',
									name: 'TravelExpenseList',
									component: TravelExpenseList,
									meta: {
										label: 'Viáticos',
										requiresAuth: true
									}
								},
								{
									path: 'travel-expense/:id',
									name: 'TravelExpenseDetail',
									component: TravelExpenseDetail,
									meta: {
										label: 'Detalle de Viáticos',
										requiresAuth: true
									}
								},
							]
						},
					]
				}
			]
		},
		{
			path: '/pages',
			redirect: '/pages/404',
			name: 'Pages',
			component: {
				render(c) {
					return c('router-view')
				}
			},
			children: [
				{
					path: '404',
					name: 'Page404',
					component: Page404
				},
				{
					path: '500',
					name: 'Page500',
					component: Page500
				},
				{
					path: 'login',
					name: 'Login',
					component: Login
				},
				{
					path: 'register',
					name: 'Register',
					component: Register
				}
			]
		},
		{
			path: '/logout',
			name: 'Logout',
			component: LogOut
		},
		{
			path: '/forgot-password',
			name: 'ForgotPassword',
			component: ForgotPassword,
			meta: {
				label: 'Recuperar Contraseña',
			}
		},
		{
			path: '/set-password',
			name: 'SetPassword',
			component: SetPasswordForm,
			meta: {
				label: 'Restablecer Contraseña',
			}
		},
		{
			path: '/auth',
			name: 'Auth',
			component: DefaultContainer,
			meta: {
				label: 'Cuenta'
			},
			children: [
				{
					path: 'user-detail',
					name: 'UserDetail',
					component: User,
					meta: {
						label: 'Detalle de Usuario',
						requiresAuth: true
					}
				},
				{
					path: 'change-password',
					name: 'ChangePassword',
					component: ChangePassword,
					meta: {
						label: 'Cambiar Contraseña',
						requiresAuth: true
					}
				}
			]
		}
	]
}

let router = new Router({
	mode: 'hash', // https://router.vuejs.org/api/#mode
	linkActiveClass: 'open active',
	scrollBehavior: () => ({y: 0}),
	routes: configRoutes()
});

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (store.getters.isLoggedIn) {
			next();
			return
		}
		next('/pages/login')
	} else {
		next()
	}
});

export default router;
